import { FetchAttendingEventsParams } from "store/attendingEvents/attendingEvents.types";
import { SearchDocumentsPayload } from "store/eventList/EventList.types";

import { CreateEventData } from "types";
import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/activity";

const api = getApi(fetchURL);

export const getMinimalEvents = async (payload: SearchDocumentsPayload) => {
  const response = await api.post("/searchDocuments", payload);
  return response.data;
};

export const getEvents = (data: { dataPage: number }) =>
  api.post("/searchDocuments", data).then((r) => r.data);

export const getEventByEventId = (data: { id: number }) =>
  api.post("/retrieveDocument", data).then((r) => r.data);

export const getEventUserInfo = (data: { id: number }) =>
  api.post("/retrieveUserInfo", data).then((r) => r.data);

export const getEventsForYou = (data: { dataPage: number }) =>
  api.get(`/retrieveForYou?dataPage=${data.dataPage}`).then((r) => r.data);

export const getWebImpactInfo = (data: {
  activityId: number;
  metrics: string[];
}) => api.post("/queryMetrics", data).then((r) => r.data);

export const getPastEvents = (data: {
  type: string;
  page: number;
  limit: number;
}) => {
  const { type, page, limit } = data;
  const queryParams = new URLSearchParams({
    type,
    page: page.toString(),
    limit: limit.toString(),
  });
  return api.get(`/getEvents?${queryParams}`).then((r) => r.data);
};

export const saveDraftEvent = (data: CreateEventData) =>
  api.post("/insertDocument", data).then((r) => r.data);

export const publishEvent = (data: CreateEventData) =>
  api.post("/publishDocument", data).then((r) => r.data);

export const updateEvent = (data: CreateEventData) =>
  api.post("/updateDocument", data).then((r) => r.data);

export const getRecommendedEvents = async (
  visitedUserId?: number
): Promise<
  Array<{
    id: number;
    activity_title: string;
    activity_description: string;
    image_url: string;
  }>
> => {
  if (visitedUserId) {
    const response = await api.post("/recommendedForYou", { visitedUserId });
    return response.data;
  } else {
    const response = await api.post("/recommendedForYou");
    return response.data;
  }
};

export const getAttendingEvents = async (data: FetchAttendingEventsParams) =>{
  try {
    const response = await api.post("/getEvents", data);
    return response.data;
  } catch (error) {
    console.error("Error fetching attending events:", error);
    throw error;
  }
}

export const requestParticipation = async (data: { activity_id: number }) => {
  try {
    const response = await api.post("/requestParticipation", data);
    return response.data;
  } catch (error) {
    console.error("Error requesting participation:", error);
    throw error;
  }
};